import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:직원관리 리스트
 * 세부설명:
*/

export class EmpList extends Component {
    static displayName = EmpList.name;

    constructor(props) {
        super(props);
        this.state = {
            EmpList: [],
            Sub_Uid:"",
            User_Name: "",
            Login_Id: "",
            Password: "",
            Content: "",
            CRUD: "I",
            RegisterSuccess: false
        };
        this.handleSubAdd_Click = this.handleSubAdd_Click.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.handleStop_Click = this.handleStop_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.CallEmpListData()
    }
    //직원 리스트 조회
    async CallEmpListData() {
        try {
            let Data = await Big3Common.Get('api/MyPage/StoreMgr/GetSubmemberList');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                //조회 리스트 등록 및 저장 후 값 초기화 속성들 설정
                this.setState({
                    EmpList: JSON.parse(Data.dataTable),
                    Sub_Uid: "",
                    User_Name: "",
                    Login_Id: "",
                    Password: "",
                    Content: "",
                    CRUD: "I",
                    RegisterSuccess: false,
                });
            }
        }
        catch (e) {
            console.log("CallEmpListData", e);
        }
    }
    //부계정 상세
    async CallSubMemberInfo(sub_uid) {
        try {
            let Data = await Big3Common.Get(`api/MyPage/StoreMgr/GetSubMemberInfo/${sub_uid}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataInfo = JSON.parse(Data.dataTable)[0];
                this.setState({
                    Sub_Uid: DataInfo.sub_uid,
                    User_Name: DataInfo.user_name,
                    Login_Id: DataInfo.login_id,
                    CRUD: "U",
                    RegisterSuccess: false,
                });
                Big3Common.ModalAlert(bootstrap, 'EmpModalBox');
            }
        }
        catch (e) {
            console.log("CallEmpListData", e);
        }
    }
    //직원추가하기(추가할 로그인 아이디 자동 생성)
    async handleSubAdd_Click(event) {
        try {
            let Data = await Big3Common.Get('api/MyPage/StoreMgr/GetSubLoginId');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const Login_Id = JSON.parse(Data.dataTable)[0].login_id;
                this.setState({
                    Login_Id: Login_Id,
                    CRUD: "I"
                });
                Big3Common.ModalAlert(bootstrap, 'EmpModalBox');
            }
        }
        catch (e) {
            console.log("handleSubAdd_Click", e);
        }
        event.preventDefault();
    }
    async handleChange(event) {
        let target = event.target;
        let tagId = target.id;
        let value = target.value.trim();
        this.setState({ [tagId]: value });
        event.preventDefault();
    }
    //직원등록
    async handleSave_Click() {
         
        if (this.state.User_Name.trim().length === 0) {
            this.setState({ Content: "직원명을 입력하여 주세요." });
        }
        else if (this.state.CRUD === "I" && this.state.Password.trim().length === 0) {
            this.setState({ Content: "비밀번호를 입력하여 주세요." });

        }
        else if (this.state.CRUD === "I" && !Big3Common.Util.isPassWordValid(this.state.Password)) {
            this.setState({ Content: "영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요" });
        }
        else if (this.state.CRUD === "U" && this.state.Password.trim().length > 0 && !Big3Common.Util.isPassWordValid(this.state.Password)) {
            this.setState({ Content: "영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요" });
        }
        else {
            let Model = {
                Sub_Uid: this.state.Sub_Uid,
                User_Name: this.state.User_Name,
                Password: this.state.Password,
                Login_Id: this.state.Login_Id,
            };
            let postUrl = this.state.CRUD === "I" ? "api/MyPage/StoreMgr/RegisterSubmember" : "api/MyPage/StoreMgr/ModifySubmember";

            let Data = await Big3Common.Post(postUrl, Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Content: Data.message, RegisterSuccess: true });
            }
            else {
                this.setState({ Content: Data.message });
            }
        }
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        return false;
    }
    //저장후 후처리
    handleMove_Click() {
        if (this.state.RegisterSuccess) {
            Big3Common.ModalClose(bootstrap, 'EmpModalBox');
            this.CallEmpListData();
        }
    }
    //사용중지
    async handleStop_Click() {

        let Data = await Big3Common.Get(`api/MyPage/StoreMgr/ModifySubmemberUseYn/${this.state.Sub_Uid}`);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            this.setState({ Content: Data.message, RegisterSuccess: true });
        }
        else {
            this.setState({ Content: Data.message });
        }
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        return false;
    }
    //버튼 랜더링
    Buttonrender() {
        if (this.state.CRUD === "I") {
            return (
                <div className="modal-footer notice_modal_footer">
                    <button type="button" className="m_btn" onClick={this.handleSave_Click}>직원계정 요청</button>
                </div>
            );
        }
        else {
            return (
                <div className="modal-footer notice_modal_footer">
                    <button type="button" className="m_btn m_btn2" onClick={() => {
                        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
                    }}>사용중지</button>
                    <button type="button" className="m_btn m_btn2" onClick={this.handleSave_Click}>직원정보변경</button>
                </div>
            );
        }
    }
    EmpAddrender() {
        let Buttonrender = this.Buttonrender();
        return (
            <form>
                <div className="modal fade" id="EmpModalBox" tabIndex="-1" data-bs-keyboard="false" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content EmpDtl_modal">
                            <div className="modal-header EmpDtl_modal_header">
                                <div className="modal-title">직원계정 요청</div>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="employee_info_box bn">
                                    <div className="input_line">
                                        <label>직원명</label>
                                        <input type="text"
                                        id="User_Name"
                                        className="form-control"
                                        maxLength="20"
                                        value={this.state.User_Name}
                                        onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="input_line">
                                        <label>아이디</label>
                                        <input type="text" id="Login_Id" className="form-control" defaultValue={this.state.Login_Id} readOnly maxLength="20" />
                                    </div>
                                    <div className="input_line last">
                                    <label>비밀번호</label>
                                    <input type="password"
                                            className="form-control"
                                            id="Password"
                                            maxLength="20"
                                            autoComplete="off"
                                            value={this.state.Password}
                                            onChange={this.handleChange}
                                    />
                                    </div>
                                </div>
                            </div>
                            {Buttonrender}
                        </div>
                    </div>
                </div>
            </form>
            )
    }
    render() {
        let EmpList = this.state.EmpList;
        let EmpAddModal = this.EmpAddrender();
        return (
            <>
                <div className="p_b_margin container_box d_padding">
                    {
                        EmpList.map((list, idx) =>
                            <div className="employee_box" key={list.sub_uid}>
                                <div className="label">직원{idx+1}</div>
                                <div className="employee_name_box">
                                    <div className="employee_name">{list.user_name }</div>                                    
                                    <div className="plus_button" onClick={() => {
                                        this.CallSubMemberInfo(list.sub_uid);
                                    }}></div>
                                </div>
                            </div>
                        )
                    }
                </div>
                <div className="catagory_button_box" onClick={this.handleSubAdd_Click }>
                    <button type="button" className="btn_v btn_v1">직원추가하기</button>
                </div>
                {EmpAddModal}
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="직원계정관리"
                    AlertClick={this.handleMove_Click}
                />
                <Confirm
                    id="ConfirmBox"
                    title="직원계정관리"
                    content="계정 사용을 중지하면 더 이상 사용할 수 없습니다.<br/>계속 진행하시겠습니까?"
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleStop_Click();
                    }}
                />
            </>
        );
    }
}
